<div class="d-flex gap-4">
  <magieno-input-text-field
          [advancedFormControl]="this.connectedCorporationForm.formElements.title | asAdvancedFormControl"></magieno-input-text-field>
</div>

<div class="d-flex gap-4 mt-3">
  <magieno-input-money-field
          class=""
          [advancedFormControl]="this.connectedCorporationForm.formElements.nonEligibleDividendReceived | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-money-field
          [advancedFormControl]="this.connectedCorporationForm.formElements.eligibleDividendReceived | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-money-field
          [advancedFormControl]="this.connectedCorporationForm.formElements.totalDividendPaid | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
</div>
<div class="d-flex gap-4 mt-3">
  <magieno-input-money-field
          [advancedFormControl]="this.connectedCorporationForm.formElements.dividendRefundNonEligible | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-money-field
          [advancedFormControl]="this.connectedCorporationForm.formElements.dividendRefundEligible | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
</div>




